import React, { Suspense, lazy, useEffect } from 'react';
import {
  BrowserRouter as Router,
  useLocation,
  Routes,
  Route
} from 'react-router-dom';
import Navbar from './components/Navbar';
// import Services from './components/Services';
// import Features from './components/Features';
// import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

const Hero = lazy(() => import('./components/Hero'));
const Rules = lazy(() => import('./components/Rules'));
const Shop = lazy(() => import('./components/Shop'));
const ShopRules = lazy(() => import('./components/ShopRules'));
const PaymentDetail = lazy(() => import('./components/PaymentDetail'));
const NotFound = lazy(() => import('./components/NotFound'));
const AdminDashboard = lazy(() => import('./components/AdminDashboard'));
const DISCORD_INVITE_URL = 'https://discord.gg/RWUStQWxYB';

const ExternalRedirect: React.FC<{ to: string }> = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <div className="route-loading">در حال انتقال...</div>;
};

const AppLayout: React.FC = () => {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/Admin');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    const titles: Record<string, string> = {
      '/': 'خانه', '/store': 'فروشگاه', '/rules': 'قوانین سرور',
      '/store/rules': 'قوانین فروشگاه', '/store/PaymentDetail': 'وضعیت پرداخت',
      '/Admin/dashboard': 'مدیریت'
    };
    document.title = `${titles[location.pathname] || 'صفحه یافت نشد'} | SculkMC`;
  }, [location.pathname]);

  return (
    <div className="App" style={{ '--world-image': `url("${process.env.PUBLIC_URL}/art/sculk-world-v1.png")` } as React.CSSProperties}>
      <a className="skip-link" href="#main-content">رفتن به محتوا</a>
      {!hideNavbar && <Navbar />}
      <main id="main-content" tabIndex={-1}>
        <Suspense fallback={<div className="route-loading">در حال بارگذاری...</div>}>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                {/* <Services /> */}
                {/* <Features /> */}
                {/* <Contact /> */}
              </>
            } />
            <Route path="/rules" element={<Rules />} />
            <Route path="/store" element={<Shop />} />
            <Route path="/store/rules" element={<ShopRules />} />
            <Route path="/store/PaymentDetail" element={<PaymentDetail />} />
            <Route path="/Admin/dashboard" element={<AdminDashboard />} />
            <Route path="/discord" element={<ExternalRedirect to={DISCORD_INVITE_URL} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App; 
